import { delay, race } from 'redux-saga/effects';

export function* binProcess(binNumber) {
  const start = new Date();
  try {
    const response = yield window.Cardinal.trigger('bin.process', binNumber);
    // Bin profiling succeeded
    if (response.Status) {
      return binProcessSuccess(start);
    }
    // Bin profiling failed
    return binProcessFailure(start, false);
  } catch (error) {
    // An error occurred during profiling
    return binProcessFailure(start, false);
  }
}

export function* binProcessWithTimeout(binDectionNumber, binProcessMaxTimeout) {
  const start = new Date();
  try {
    const { response } = yield race({
      response: window.Cardinal.trigger('bin.process', binDectionNumber),
      timeout: delay(binProcessMaxTimeout),
    });
    if (response) {
      // Bin profiling succeeded
      if (response.Status) {
        return binProcessSuccess(start);
      }
      // Bin profiling failed
      return binProcessFailure(start, false);
    }
    // timed out
    return binProcessFailure(start, true);
  } catch (error) {
    // An error occurred during profiling
    return binProcessFailure(start, false);
  }
}

export const binProcessSuccess = (binStartTime) => ({
  binProcessEventSuccess: 'true',
  binProcessEventTimedOut: 'false',
  binProcessEventTime: (new Date() - binStartTime).toString(10),
});

export const binProcessFailure = (binStartTime, isTimedOut) => ({
  binProcessEventSuccess: 'false',
  binProcessEventTimedOut: isTimedOut,
  binProcessEventTime: (new Date() - binStartTime).toString(10),
});
